import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const navLinks = [
    { path: '/', label: 'Network' },
    { path: '/resources', label: 'Resources' },
    { path: '/gear', label: 'Find Gear' },
    { path: '/calendar', label: 'Calendar' },
    { path: '/about', label: 'About' }
  ];

  return (
    <nav className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="/images/sbn-logo-L.png" 
              alt="Southern Bee Network" 
              className="h-8 w-auto"
            />
            <span className="text-xl font-bold text-slate-700">Southern Bee Network</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/directory"
              className={`font-medium transition-colors ${
                isActive('/directory')
                  ? 'text-slate-700 border-b-2 border-slate-700'
                  : 'text-gray-700 hover:text-slate-700'
              }`}
            >
              Find Sellers
            </Link>
            <Link
              to="/premium"
              className={`font-medium transition-colors ${
                isActive('/premium')
                  ? 'text-slate-700 border-b-2 border-slate-700'
                  : 'text-gray-700 hover:text-slate-700'
              }`}
            >
              Premium
            </Link>
            <Link
              to="/about"
              className={`font-medium transition-colors ${
                isActive('/about')
                  ? 'text-slate-700 border-b-2 border-slate-700'
                  : 'text-gray-700 hover:text-slate-700'
              }`}
            >
              About
            </Link>
            
            {/* Authentication Buttons */}
            <div className="flex items-center space-x-4">
              <Link
                to="/login"
                className="text-gray-700 hover:text-slate-700 font-medium"
              >
                Sign In
              </Link>
              <Link
                to="/register"
                className="bg-yellow-600 hover:bg-yellow-700 text-white px-4 py-2 rounded-md font-medium transition-colors"
              >
                Join Network
              </Link>
            </div>
            
            <div className="flex items-center space-x-4 ml-8">
              <Link
                to="/register"
                className="bg-slate-700 text-white px-4 py-2 rounded-lg hover:bg-slate-800 transition-colors font-medium"
              >
                Join Network
              </Link>
              <Link
                to="/login"
                className="text-gray-700 hover:text-slate-700 font-medium"
              >
                Sign In
              </Link>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? (
              <XMarkIcon className="w-6 h-6" />
            ) : (
              <Bars3Icon className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`font-medium transition-colors ${
                    isActive(link.path)
                      ? 'text-slate-700'
                      : 'text-gray-700 hover:text-slate-700'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
              
              <div className="flex flex-col space-y-2 pt-4 border-t border-gray-200">
                <Link
                  to="/register"
                  className="bg-slate-700 text-white px-4 py-2 rounded-lg hover:bg-slate-800 transition-colors font-medium text-center"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Join Network
                </Link>
                <Link
                  to="/login"
                  className="text-gray-700 hover:text-slate-700 font-medium text-center"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Sign In
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;